module.exports = __webpack_public_path__ + "logo.0d0446f05fc2a9c12f24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/private/logo.png
// module id = ./src/assets/images/private/logo.png
// module chunks = main